import he from "he";
import sanitizeHtml from "sanitize-html";

const DECODE_PASSES = 5;

const decodeMulti = value => {
  const startTime = Date.now();
  let decodedValue = typeof value === "string" ? value : value == null ? "" : String(value);
  let decodeSteps = 0;

  for (let decodeIndex = 0; decodeIndex < DECODE_PASSES; decodeIndex += 1) {
    decodeSteps += 1;
    const nextValue = he.decode(decodedValue);

    if (nextValue === decodedValue) {
      break;
    }

    decodedValue = nextValue;
  }
  return decodedValue;
};

/** Runs {@link decodeMulti} on every string in a nested JSON-like value (objects / arrays). */
const decodeMultiDeep = value => {
  if (value == null) {
    return value;
  }
  if (typeof value === "string") {
    return decodeMulti(value);
  }
  if (Array.isArray(value)) {
    return value.map(decodeMultiDeep);
  }
  if (typeof value === "object") {
    if (value instanceof Date) {
      return value;
    }
    if (Object.prototype.toString.call(value) !== "[object Object]") {
      return value;
    }
    const out = Object.create(null);
    for (const key of Object.keys(value)) {
      if (key === "__proto__" || key === "constructor" || key === "prototype") {
        continue;
      }
      out[key] = decodeMultiDeep(value[key]);
    }
    return out;
  }
  return value;
};

const StringFormatter = {
  decodeMulti,
  decodeMultiDeep,

  truncate(text, maxLength = 80, end = "...") {
    if (text.length <= maxLength || text.length - end.length <= maxLength) {
      return text;
    }

    return String(text).substring(0, maxLength - end.length) + end;
  },

  sanitizeHtml(value) {
    const allowedAttributes = {
      div: ["style", "class", "id"],
      span: ["style", "class"],
      p: ["style", "class"],
      b: ["style", "class"],
      s: ["style", "class"],
      i: ["style", "class"],
      u: ["style", "class"],
      ul: ["style", "class", "type"],
      ol: ["style", "class"],
      li: ["style", "class"],
      strong: ["style", "class"],
      a: ["target", "href", "title", "name", "style", "rel", "class"],
    };

    return sanitizeHtml(decodeMulti(value), {
      allowedAttributes: { ...sanitizeHtml.defaults.allowedAttributes, ...allowedAttributes },
    });
  },

  stripHtml(value) {
    return sanitizeHtml(value, {
      allowedTags: [],
      allowedAttributes: {},
    });
  },

  encode(value) {
    if (typeof value === "string") {
      return he.encode(decodeMulti(value));
    }

    if (typeof value === "number") return value;
    return "";
  },

  convertUrlLink(value) {
    const url = sanitizeHtml(decodeMulti(value));
    // Escape quotes in href attribute to prevent breaking HTML
    const hrefUrl = url.replace(/"/g, "&quot;");
    return `<a target="_blank" href="${hrefUrl}">${url}</a>`;
  },
};

export default StringFormatter;
